export default __webpack_public_path__ + "static/8-5743db0be3ea262d71f663e67192b463.png";